import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { Heading4 } from "styles/elements/Headings";
import { CssFlex } from "styles/helpers/layout";

interface CardWithTitleChipProps extends Props {
  $comingSoon?: boolean;
}

export const StyledCard = styled(CssFlex)<Props>`
  min-width: 20rem;
  cursor: pointer;
  border: solid 1px;
  border-color: ${(props: Props) => props.theme.palette.neutral._800};

  &:hover {
    transition: all 0.2s ease-in-out;
    box-shadow: 0px 11px 27px 0px rgba(84, 84, 84, 0.2);
  }
`;

export const StyledCardHeader = styled(CssFlex)<Props>`
  padding: 1rem;

  ${Heading4} {
    margin: 0;
    font-size: ${(props: Props) => props.theme.font.size._18};
    line-height: normal;

    max-width: 100%;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
`;

export const StyledCardContent = styled(CssFlex)<Props>`
  height: 100%;
  padding: 1rem;
  overflow: auto;
`;

export const StyledTitleChip = styled(CssFlex)<CardWithTitleChipProps>`
  padding: 0.5rem 1rem;
  background-color: ${({ theme, $comingSoon }: CardWithTitleChipProps) => ($comingSoon ? theme.palette.red._950 : theme.palette.primary._700)};
  border-radius: 20px;
  gap: 0.5rem;
`;
